import { connect } from 'react-redux'
import { getOutput } from 'selectors/feature/outputs'
import { makeConditionSimulationSelector } from 'selectors/feature/simulation'
import {
  updateSimulatedValue,
  resetSimulatedValue,
} from 'actions/feature/simulation'
import OutputSimulator from './OutputSimulator'

const makeMapStateToProps = () => {
  //   const outputSelector = makeGetOutputQueryUri()
  const simulationSelector = makeConditionSimulationSelector()

  const mapStateToProps = (state, ownProps) => {
    const { id, mappedOutputUri } = ownProps
    const output = getOutput(state, { id })
    const simulation = simulationSelector(state, { queryUri: mappedOutputUri })

    return {
      ...output,
      ...simulation,
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateSimulatedValue: (uri, value) => {
    dispatch(updateSimulatedValue(uri, value))
  },
  resetSimulatedValue: (uri) => dispatch(resetSimulatedValue(uri)),
})

const connected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(OutputSimulator)

export default connected
